var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLoading = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 200,
  height: 200,
  preserveAspectRatio: "xMidYMid",
  viewBox: "0 0 100 100",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "M5 5h30v30H5z"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-0.4s",
  calcMode: "spline",
  dur: "1s",
  keySplines: "0.5 0.5 0.5 0.5;0 0.1 0.9 1;0.1 0 1 0.9;0.5 0.5 0.5 0.5",
  keyTimes: "0;0.2;0.5;0.8;1",
  repeatCount: "indefinite",
  type: "scale",
  values: "1;1;0.2;1;1"
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#58ACF4",
  d: "M35 5h30v30H35z"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-0.3s",
  calcMode: "spline",
  dur: "1s",
  keySplines: "0.5 0.5 0.5 0.5;0 0.1 0.9 1;0.1 0 1 0.9;0.5 0.5 0.5 0.5",
  keyTimes: "0;0.2;0.5;0.8;1",
  repeatCount: "indefinite",
  type: "scale",
  values: "1;1;0.2;1;1"
}))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#105EDD",
  d: "M65 5h30v30H65z"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-0.2s",
  calcMode: "spline",
  dur: "1s",
  keySplines: "0.5 0.5 0.5 0.5;0 0.1 0.9 1;0.1 0 1 0.9;0.5 0.5 0.5 0.5",
  keyTimes: "0;0.2;0.5;0.8;1",
  repeatCount: "indefinite",
  type: "scale",
  values: "1;1;0.2;1;1"
}))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#58ACF4",
  d: "M5 35h30v30H5z"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-0.3s",
  calcMode: "spline",
  dur: "1s",
  keySplines: "0.5 0.5 0.5 0.5;0 0.1 0.9 1;0.1 0 1 0.9;0.5 0.5 0.5 0.5",
  keyTimes: "0;0.2;0.5;0.8;1",
  repeatCount: "indefinite",
  type: "scale",
  values: "1;1;0.2;1;1"
}))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#105EDD",
  d: "M35 35h30v30H35z"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-0.2s",
  calcMode: "spline",
  dur: "1s",
  keySplines: "0.5 0.5 0.5 0.5;0 0.1 0.9 1;0.1 0 1 0.9;0.5 0.5 0.5 0.5",
  keyTimes: "0;0.2;0.5;0.8;1",
  repeatCount: "indefinite",
  type: "scale",
  values: "1;1;0.2;1;1"
}))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#0B3075",
  d: "M65 35h30v30H65z"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-0.1s",
  calcMode: "spline",
  dur: "1s",
  keySplines: "0.5 0.5 0.5 0.5;0 0.1 0.9 1;0.1 0 1 0.9;0.5 0.5 0.5 0.5",
  keyTimes: "0;0.2;0.5;0.8;1",
  repeatCount: "indefinite",
  type: "scale",
  values: "1;1;0.2;1;1"
}))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#105EDD",
  d: "M5 65h30v30H5z"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-0.2s",
  calcMode: "spline",
  dur: "1s",
  keySplines: "0.5 0.5 0.5 0.5;0 0.1 0.9 1;0.1 0 1 0.9;0.5 0.5 0.5 0.5",
  keyTimes: "0;0.2;0.5;0.8;1",
  repeatCount: "indefinite",
  type: "scale",
  values: "1;1;0.2;1;1"
}))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#0B3075",
  d: "M35 65h30v30H35z"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  begin: "-0.1s",
  calcMode: "spline",
  dur: "1s",
  keySplines: "0.5 0.5 0.5 0.5;0 0.1 0.9 1;0.1 0 1 0.9;0.5 0.5 0.5 0.5",
  keyTimes: "0;0.2;0.5;0.8;1",
  repeatCount: "indefinite",
  type: "scale",
  values: "1;1;0.2;1;1"
}))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "M65 65h30v30H65z"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  begin: "0s",
  calcMode: "spline",
  dur: "1s",
  keySplines: "0.5 0.5 0.5 0.5;0 0.1 0.9 1;0.1 0 1 0.9;0.5 0.5 0.5 0.5",
  keyTimes: "0;0.2;0.5;0.8;1",
  repeatCount: "indefinite",
  type: "scale",
  values: "1;1;0.2;1;1"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLoading);
export default ForwardRef;